// tslint:disable
/**
 * LXBackend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    SearchSuggestion,
    SearchSuggestionFromJSON,
    SearchSuggestionToJSON,
} from './';

/**
 * 
 * @export
 * @interface SearchSuggestionResponse
 */
export interface SearchSuggestionResponse {
    /**
     * 
     * @type {Array<SearchSuggestion>}
     * @memberof SearchSuggestionResponse
     */
    results: Array<SearchSuggestion>;
}

export function SearchSuggestionResponseFromJSON(json: any): SearchSuggestionResponse {
    return {
        'results': (json['results'] as Array<any>).map(SearchSuggestionFromJSON),
    };
}

export function SearchSuggestionResponseToJSON(value?: SearchSuggestionResponse): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'results': (value.results as Array<any>).map(SearchSuggestionToJSON),
    };
}


